import { render, staticRenderFns } from "./ExtTextInputDialog.vue?vue&type=template&id=524f2634"
import script from "./ExtTextInputDialog.vue?vue&type=script&lang=js"
export * from "./ExtTextInputDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports